import { keyframes, css } from 'styled-components'

const fadeIn = keyframes`
  from {
    opacity: 30%;
  }

  44% {
    opacity: 100%;
  }

  55% {
    opacity: 100%;
  }

  to {
    opacity: 30%;
  }
`

const animation = css`
  animation: ${fadeIn} 1700ms cubic-bezier(0.87, 0, 0.13, 1); /* easeInOutExpo */
`

export default animation
